import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import MobileBottomBar from "./MobileBottomBar";
import { Outlet } from "react-router-dom";

const Layout: React.FC = () => (
  <div className="flex flex-col min-h-screen bg-gray-50">
    <Header />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
    <MobileBottomBar variant="home" />
  </div>
);

export default Layout;